import { render, staticRenderFns } from "./UrunDetayi.vue?vue&type=template&id=564b30cc&"
import script from "./UrunDetayi.vue?vue&type=script&lang=js&"
export * from "./UrunDetayi.vue?vue&type=script&lang=js&"
import style0 from "./UrunDetayi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports